export default __webpack_public_path__ + "static/media/investImg.8ea58630.svg";